export default "__VITE_ASSET__CQRNjJBT__"